<template>
  <div>
    <!-- class="home-color" -->
    <!-- class="home-background" -->
    <div class="home-background">
      <el-row style="text-align: center;">
        <el-col :span="23" :offset="1" style="margin-top: 100px;">
          <div style="color: white; ">
            <div style="font-size:40px; font-weight: 600;">Open Biomedical Imaging Archive</div>
            <p style="margin-top: 20px;font-size:18px;line-height: 1.5;">
              The Open Biomedical Imaging Archive (OBIA) is a repository for archiving biomedical imaging data and related clinical data.
              <!-- We provide high-quality, open and accessible imaging datasets that facilitate the reuse of existing medical imaging and clinical data. -->
            </p>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="14" :offset="5" style="margin-top: 50px;">
          <Search></Search>
        </el-col>
      </el-row>
      <el-row style="height: 100px;"></el-row>
    </div>

    <div>
      <el-row style="margin-top: 30px;">
        <el-col>
          <CountNumCard></CountNumCard>
        </el-col>
      </el-row>
      <!-- <el-row style="margin-top: 10px; margin-bottom: 50px;">
        <el-col :span="13" :offset="1">
          <CountNum></CountNum>
        </el-col>
      </el-row> -->
      <!-- <el-row style="background: -webkit-linear-gradient(left,#4D7C8A,#447182,#3B657A,#325971,#294D68,#1F415F,#163556,#0D294D,#082349,#031D44)">
        <el-col :span="24">
          <div class="cite">
            <div style="margin: 20px 40px 20px 40px;">
            </div>
          </div>
        </el-col>
      </el-row> -->

      <el-row style="margin: 30px;" :gutter="15">
        <el-col>
          <div class="box-parent">
            <div class="box-child" style="width: 50%;">
              <div class="cite-title">How to cite:</div>
              <div class="cite-content">
                OBIA: An Open Biomedical Imaging Archive. Genomics, Proteomics & Bioinformatics 2023.
                <a class="cite-link" target="_blank" href="https://doi.org/10.1016/j.gpb.2023.09.003">https://doi.org/10.1016/j.gpb.2023.09.003</a>
                [PMID=37806555]
              </div>
              <!-- <div class="cite-content">
                Database Resources of the National Genomics Data Center, China National Center for Bioinformation in 2024. Nucleic Acids Res 2024, 51(D1):D18-D32.
                <a class="cite-link" target="_blank" href="https://doi.org/10.1093/nar/gkad1078">https://doi.org/10.1093/nar/gkad1078</a>
                [PMID=38018256]
              </div> -->
            </div>
            <div style="display: table-cell; word-wrap: break-word; width: 15px;"></div>
            <div class="box-child">
              <div class="cite-title">Help & Support:</div>
              <div class="cite-content">
                If you have any question or would like to give us any suggestion/comment or report a bug, please feel free to contact us.
                <br /><b>Email: </b><a class="mail-link" href="mailto:obia@big.ac.cn">obia@big.ac.cn</a>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row style="margin: 30px;" :gutter="15">
        <el-col>
          <div style="background-color: rgba(49,68,98,0.1);text-align: left;border-radius: 5px;border:1px solid transparent">
            <div style="padding: 10px 0px 10px 30px;">
              <span class="cite-content">
                <b>Licenses:</b> The Open Biomedical Imaging Archive (OBIA) is free for academic use only. For any commercial use, please contact us for commercial licensing terms.
              </span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- <HumanBody></HumanBody> -->

    <!-- <Modality></Modality> -->
  </div>
</template>

<script>
// import CountNum from '../components/home/CountNum'
import CountNumCard from '../components/home/CountNumCard'
// import DrawPeople from '../components/home/DrawPeople'
import Search from '../components/home/Search'
// import Modality from '../components/home/Modality'
// import HumanBody from '../components/home/HumanBody'

export default {
  name: 'Home',
  components: { CountNumCard, Search },

  data () {
    return {}
  },
  methods: {},
  created () {},
  mounted () {}
}
</script>

<style>
/* 全屏背景 */
.home-background {
  background: url('../assets/home/back5.png');
  background-size: cover;
}

/* 渐变色背景 */
.home-color {
  background: -webkit-linear-gradient(left, #4d7c8a, #447182, #3b657a, #325971, #294d68, #1f415f, #163556, #0d294d, #082349, #031d44);
  /* background: -webkit-linear-gradient(left,rgba(77,124,138,0.5),rgba(68,113,130,0.5),rgba(59,101,122,0.5),rgba(50,89,113,0.5),rgba(41,77,104,0.5),rgba(31,65,95,0.5),rgba(22,53,86,0.5),rgba(13,41,77,0.5),rgba(8,35,73,0.5),rgba(3,29,68,0.5)) */
}

.box-parent {
  display: table;
  width: 100%;
}

.box-child {
  display: table-cell;
  word-wrap: break-word;
  border: 1px solid rgba(49, 68, 98, 0.2);
  border-radius: 5px;
  text-align: left;
  padding: 20px 30px 20px 30px;
}

.cite-title {
  /* color: #e1e8eb; */
  color: #1f415f;
  font-size: 20px;
  line-height: 2;
  font-weight: 600;
}

.cite-content {
  line-height: 1.5;
  /* color: #e1e8eb; */
  color: black;
  font-size: 16px;
}

.cite-link {
  color: #0c64b6;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue